
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60.5","height":"52.4","viewBox":"0 0 60.5 52.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#DDDAC5","d":"M22 47.8l-.2-.2-.4.5-17.9-18 8.4-8.3 9.6 9.6L48.6 4.3l8.4 8.5z"}})])
          )
        }
      }
    